module.exports = __webpack_public_path__ + "static/media/RULEBOOK_CHINESE.ea8bb8e4.pdf";